export { default } from 'ember-super-prosemirror/components/super-text-editor/link-prompt';
